import { render, staticRenderFns } from "./EnacProcedureAtpDafEditRestoreDraft.vue?vue&type=template&id=60e5baa0"
import script from "./EnacProcedureAtpDafEditRestoreDraft.vue?vue&type=script&lang=js"
export * from "./EnacProcedureAtpDafEditRestoreDraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports